import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=36389248"
import script from "./Tambah.vue?vue&type=script&lang=js"
export * from "./Tambah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports